import {ShoppingDiagnosticsData} from '../../../integrated-client/models/ShoppingDiagnosticsData'

export interface IResultsDataHistorical {
  shoppingResults: ShoppingDiagnosticsData
  correlationId: string | null
  shoppingRequestDurationMs: number | null
}

export class ResultsData implements IResultsDataHistorical {
  shoppingResults: ShoppingDiagnosticsData
  correlationId: string | null
  shoppingRequestDurationMs: number | null

  constructor() {
    this.shoppingResults = {};
    this.correlationId = null
    this.shoppingRequestDurationMs = null
  }
}
